import { createSlice } from '@reduxjs/toolkit';
import myAccountTabsData from '../../components/MyAccount/myAccountTabsData';

const publicSlice = createSlice({
    name: "public",
    initialState: {
        MY_ACCOUNT_TAB: myAccountTabsData[2]?.tabName,
    },
    reducers: {
        setMyAccountActiveTab: (state, action) => {
            state.MY_ACCOUNT_TAB = action.payload;
        },
        resetPublicState: (state) => {
            state.MY_ACCOUNT_TAB = myAccountTabsData[2]?.tabName;
        }
    },
});

export const { setMyAccountActiveTab, resetPublicState } = publicSlice.actions;

export default publicSlice.reducer;